export default class SelectedSoftwareChangeDispatcher {
  public static EVENT_TYPE: string = 'selectedSoftwareChange';

  public static dispatchEvent() {
    const event = new CustomEvent(this.EVENT_TYPE);
    window.dispatchEvent(event);
  }
}
